<template>
  <div class="grid flex justify-content-center mt-2">
    <div class="col-4 md:col-6 sm:12">
      <div class="w-full">
        <div class="grid">
          <Toast />
          <div class="col-12">
            <Card class="scalein animation-duration-500">
              <template #title>
                Step {{StepNumber}} of 3
                <Chip label="Confirm Details" icon="pi pi-money-bill" class="ml-3 surface-800" />


              </template>
              <template #content>
                <div class="col-12">
                  <Menu :model="ConfirmMenuItems" style="width:100%" />
                </div>
                  <div class="col-12 mt-2">
                    <div class="w-full">
                      <div class="text-900 text-xl mb-3 text-left font-medium">Change your account tier</div>
                      <div class="surface-border border-1 p-3 border-round-top flex align-items-center cursor-pointer" :class="{'surface-card': tier2 !== 0, 'bg-primary': tier2 === 0}" @click="tier2 = 0">
                        <div class="w-4 flex align-items-center pr-4">
                          <RadioButton name="tier2" :value="0" v-model="tier2" class="mr-2"></RadioButton>
                          <div class="font-medium" :class="{'text-900': tier2 !== 0, 'bg-primary': tier2 === 0}">Basic</div>
                        </div>
                        <div class="w-4 text-center">
                          <span class="bg-blue-100 text-blue-700 font-medium px-2 py-1" style="border-radius:12px">Save 20%</span>
                        </div>
                        <div class="w-4 text-right">
                          <span class="font-medium" :class="{'text-900': tier2 !== 0, 'bg-primary': tier2 === 0}">19$</span>
                          <span :class="{'text-600': tier2 !== 0, 'bg-primary': tier2 === 0}"> / Month</span>
                        </div>
                      </div>
                      <div class="surface-border border-1 p-3 border-top-none flex align-items-center cursor-pointer" :class="{'surface-card': tier2 !== 1, 'bg-primary': tier2 === 1}" @click="tier2 = 1">
                        <div class="w-4 flex align-items-center pr-4">
                          <RadioButton name="tier2" :value="1" v-model="tier2" class="mr-2"></RadioButton>
                          <div class="font-medium" :class="{'text-900': tier2 !== 1, 'bg-primary': tier2 === 1}">Premium</div>
                        </div>
                        <div class="w-4 text-center">
                          <span class="bg-blue-100 text-blue-700 font-medium px-2 py-1" style="border-radius:12px">Save 25%</span>
                        </div>
                        <div class="w-4 text-right">
                          <span class="font-medium" :class="{'text-900': tier2 !== 1, 'bg-primary': tier2 === 1}">29$</span>
                          <span :class="{'text-600': tier2 !== 1, 'bg-primary': tier2 === 1}"> / Month</span>
                        </div>
                      </div>
                      <div class="surface-border border-1 border-top-none p-3 border-round-bottom flex align-items-center cursor-pointer" :class="{'surface-card': tier2 !== 2, 'bg-primary': tier2 === 2}" @click="tier2 = 2">
                        <div class="w-4 flex align-items-center pr-4">
                          <RadioButton name="tier2" :value="2" v-model="tier2" class="mr-2"></RadioButton>
                          <div class="font-medium" :class="{'text-900': tier2 !== 2, 'bg-primary': tier2 === 2}">Enterprise</div>
                        </div>
                        <div class="w-4 text-center">
                          <span class="bg-blue-100 text-blue-700 font-medium px-2 py-1" style="border-radius:12px">Save 50%</span>
                        </div>
                        <div class="w-4 text-right">
                          <span class="font-medium" :class="{'text-900': tier2 !== 2, 'bg-primary': tier2 === 2}">39$</span>
                          <span :class="{'text-600': tier2 !== 2, 'bg-primary': tier2 === 2}"> / Month</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <span class="p-buttonset ml-0 pl-0">
                      <Button label="Back" icon="pi pi-arrow-circle-left" style="width:50%" class="surface-800" @click="Back"/>
                      <Button label="Subscribe" icon="pi pi-check" iconPos="right" style="width:50%" class="bg-orange-600" />
                    </span>
                  </div>
              </template>
              <!--<template #footer>
        <div class="flex justify-content-end">
          <Button icon="pi pi-check" iconPos="right" :label="BtnText" class="bg-orange-600 mt-0 btn-block" style="margin-left: .5em" @click="NextStep" :disabled="v$.$invalid" :loading="IsCreating" />
        </div>
      </template>-->
            </Card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style>
  .p-inputwrapper {
    width: 100% !important;
  }

  .p-chip {
    background-color: black;
    color: white;
  }
</style>

<script>

  /* eslint-disable no-debugger, no-unused-vars */
  //import Splitter from 'primevue/splitter';
  //import SplitterPanel from 'primevue/splitterpanel';
  import Card from 'primevue/card';
  import Button from 'primevue/button';
  import Chip from 'primevue/chip';
  import { loadStripe } from '@stripe/stripe-js';
  import Menu from 'primevue/menu';
  import Toast from 'primevue/toast';


  export default {
    name: 'StepThree',
    props: ['SubscriptionId', 'Email', 'StripeCustomerId'],
    components: {
      Chip,
      Menu,
      Toast,
      //Splitter,
      //SplitterPanel,
      Card,
      Button
    },
    data: () => ({
      checkbox: true,
      overlay: true,
      Tier: '',
      Subscriptions:[],
      IsSigningUp: false,
      BtnText: 'Start Membership',
      StripeKey:'',
      User: {
        FirstName: '',
        LastName: '',
        Email: '',
        Password: ''
      },
      StepNumber: 3,
      ConfirmMenuItems: []
    }),
    async mounted() {

      var self = this;
      await this.$http.post('/Authorization/GetCurrentSubscriptions', {}).then(function (response) {
        self.Subscriptions = response.data.subscriptions;
        self.StripeKey = response.data.stripeKey;
      })

      var getSubscription = self.Subscriptions.filter(x => x.subscriptionId === this.SubscriptionId)[0]

      var price = getSubscription.subscriptionPrice;
      var subscriptionName = getSubscription.subscritionName;

      price = price == 0 ? "Free" : "$" + price +" /Mo"

      this.ConfirmMenuItems = [
        {
            label: subscriptionName +  " - " + price,
            icon: 'pi pi-check-circle',
            //command: () => {
            //  this.$toast.add({ severity: 'error', summary: 'Forever my love', detail: 'I love Callie', life: 3000 });
            //}
        },
      ]
      this.LoadStripe(50)
    },

    methods: {
      async LoadStripe(Amount) {

        var self = this;
        const stripe = await loadStripe(this.StripeKey);
        this.Stripe = stripe;

        await this.$http.post('/Payments/CreateIntent',
          { Amount: Amount, DevMode: 1000 }).then(function (response) {
            if (response.data.success) {
              const elements = stripe.elements({ clientSecret: response.data.paymentIntent.client_secret });
              var card = elements.create("card");
              self.Elements = card;

              var style = {
                base: {
                  color: "#32325d",
                }
              };

              // Stripe injects an iframe into the DOM
              card.mount("#card-element", { style: style });
              self.Card = card;

              card.on('change', ({ error }) => {
                let displayError = document.getElementById('card-errors');
                if (error) {
                  displayError.textContent = error.message;
                } else {
                  displayError.textContent = '';
                }
              });
            }
          })

      },
      Subscribe: function () {
        this.$router.push({ name: 'SignUp', params: { Email: this.state.EmailAddress } })
      },
      async SubmitPayment() {
        var self = this;
        self.IsSigningUp = true;
        var paymentToken;
        var hasError = false;

        await self.Stripe.createToken(self.Card).then(function (result) {
          if (result.error) {
            hasError = true;
        /*    self.$toast.add({ severity: 'error', summary: 'Error', detail: result.error.message, life: 3000 });*/
            // Inform the customer that there was an error.
            var errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
            self.IsSigningUp = false;
          } else {
            paymentToken = result.token;
          }
        });

        if (!hasError) {
    
          await this.$http.post('/Payments/SubmitPayment', { Amount: self.Donation.Amount, Token: paymentToken.id, FirstName: self.Donation.FirstName, LastName: self.Donation.LastName, Email: self.Donation.Email, DevMode: 1000 }
          )
            .then(function (response) {
              if (response.data.success) {
                self.Donation.Submitting = false;
                self.Elements.clear();
                self.Donation = {
                  FirstName: '',
                  LastName: '',
                  Email: '',
                  Amount: 0,
                  Submitting: false
                }
              }
              else {
                self.Donation.Submitting = false;
                self.Elements.clear();
              }
            })
            .catch(function (error) {
              self.Donation.Submitting = false;
              self.Elements.clear();
            });

        }
      },
      async Back() {
        this.$emit('prev-page', { PageNumber: 2, Email: this.Email, StripeCustomerId: this.StripeCustomerId })
      },
      async NextStep() {

      
      },
    }
  }
</script>